/**
 * Shared panel container styles
 * Common styling for InfoPanel, FixGuidancePanel, and similar panel components
 */

import { makeStyles, tokens } from '@fluentui/react-components'

export const usePanelContainerStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
    padding: tokens.spacingVerticalM,
    backgroundColor: tokens.colorNeutralBackground2,
    borderRadius: tokens.borderRadiusMedium,
  },
})
